import React, { useState } from 'react';
import { IconCheck } from './Icons';
import './ContactForm.css';

/*
  Sends contact form submissions directly to a Discord webhook.
  Set REACT_APP_CONTACT_WEBHOOK in your Netlify environment variables
  to your Discord channel webhook URL.
*/

const WEBHOOK = process.env.REACT_APP_CONTACT_WEBHOOK;

export default function ContactForm() {
  const [form, setForm]           = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError]         = useState('');
  const [loading, setLoading]     = useState(false);

  const handleChange = e =>
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      setError('Please fill in all fields.');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setError('');
    setLoading(true);

    const payload = {
      username: 'PERM Systems',
      content: `**New contact form submission**`,
      embeds: [
        {
          title: 'New Contact Form Submission',
          color: 5219560,
          fields: [
            { name: 'Name',    value: form.name,              inline: true  },
            { name: 'Email',   value: `\`${form.email}\``,   inline: true  },
            { name: 'Message', value: form.message,           inline: false },
          ],
          footer: { text: 'PERM Systems Contact Form' },
          timestamp: new Date().toISOString(),
        },
      ],
    };

    try {
      const res = await fetch(WEBHOOK, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const body = await res.text().catch(() => '');
        console.error('Discord webhook error', res.status, body);
        throw new Error(`Discord returned ${res.status}`);
      }
      setSubmitted(true);
    } catch (err) {
      setError('Something went wrong. Please try again or reach us on Discord.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="cf cf--success animate-fade-up">
        <div className="cf__success-icon">
          <IconCheck size={22} color="#1a9a5c" />
        </div>
        <h3>Message received</h3>
        <p>Thanks for reaching out. We will get back to you within 24 to 48 hours.</p>
        <button className="btn btn--outline btn--sm"
          onClick={() => { setSubmitted(false); setForm({ name:'', email:'', message:'' }); }}>
          Send another message
        </button>
      </div>
    );
  }

  return (
    <form className="cf animate-fade-up" onSubmit={handleSubmit} noValidate>
      {error && <p className="cf__error">{error}</p>}
      <div className="cf__row">
        <div className="cf__group">
          <label htmlFor="cf-name">Name</label>
          <input id="cf-name" name="name" type="text" placeholder="Your name"
            value={form.name} onChange={handleChange} autoComplete="name" disabled={loading} />
        </div>
        <div className="cf__group">
          <label htmlFor="cf-email">Email</label>
          <input id="cf-email" name="email" type="email" placeholder="your@email.com"
            value={form.email} onChange={handleChange} autoComplete="email" disabled={loading} />
        </div>
      </div>
      <div className="cf__group">
        <label htmlFor="cf-message">Message</label>
        <textarea id="cf-message" name="message" rows={5} placeholder="How can we help?"
          value={form.message} onChange={handleChange} disabled={loading} />
      </div>
      <button type="submit" className="btn btn--primary btn--lg"
        style={{ width: '100%' }} disabled={loading}>
        {loading ? 'Sending...' : 'Send Message'}
      </button>
    </form>
  );
}